function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-1{fill:#fff;}.cls-2{fill:url(#radial-gradient);}.cls-3{fill:url(#radial-gradient-2);}.cls-4{fill:url(#radial-gradient-3);}.cls-5{fill:url(#radial-gradient-4);}.cls-6{fill:url(#linear-gradient);}.cls-7{fill:url(#radial-gradient-5);}.cls-8{fill:url(#radial-gradient-6);}.cls-9{fill:url(#radial-gradient-7);}.cls-10{fill:url(#linear-gradient-2);}\r\n        "), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient",
  cx: 1486.9435,
  cy: 2536.4611,
  r: 2159.6881,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f484f1",
  stopOpacity: 0.4
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1847,
  stopColor: "#f592f3",
  stopOpacity: 0.3531
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5139,
  stopColor: "#f9b9f7",
  stopOpacity: 0.2282
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9466,
  stopColor: "#fef7fe",
  stopOpacity: 0.0269
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient-2",
  cx: 1912.5,
  cy: 2732.5,
  r: 2025.5015,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ff931e",
  stopOpacity: 0.7
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0402,
  stopColor: "#ff9b2e",
  stopOpacity: 0.6506
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2155,
  stopColor: "#ffb96d",
  stopOpacity: 0.4541
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3889,
  stopColor: "#ffd2a1",
  stopOpacity: 0.291
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5568,
  stopColor: "#ffe6ca",
  stopOpacity: 0.1641
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7178,
  stopColor: "#fff4e7",
  stopOpacity: 0.0734
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8689,
  stopColor: "#fffcf9",
  stopOpacity: 0.0187
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient-3",
  cx: 275.0601,
  cy: 1539.6519,
  r: 953.7937,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.0838,
  stopColor: "#f484f1",
  stopOpacity: 0.4
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4972,
  stopColor: "#f486f1",
  stopOpacity: 0.3923
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6465,
  stopColor: "#f58ff2",
  stopOpacity: 0.3645
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.753,
  stopColor: "#f69ef4",
  stopOpacity: 0.316
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8391,
  stopColor: "#f8b3f6",
  stopOpacity: 0.2467
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9128,
  stopColor: "#fbcffa",
  stopOpacity: 0.1566
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.977,
  stopColor: "#fef0fd",
  stopOpacity: 0.0475
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient-4",
  cx: -132.5,
  cy: 2995,
  r: 2255.4454,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b1bed1",
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1608,
  stopColor: "#b7c3d4",
  stopOpacity: 0.463
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4068,
  stopColor: "#c7d0de",
  stopOpacity: 0.3612
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7055,
  stopColor: "#e0e6ed",
  stopOpacity: 0.1958
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: -900.8272,
  y1: 389.1728,
  x2: 2719.5135,
  y2: 4009.5135,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fefefe",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3683,
  stopColor: "#fdfdfe",
  stopOpacity: 0.009
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.501,
  stopColor: "#fbfbfc",
  stopOpacity: 0.0415
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5957,
  stopColor: "#f6f8fa",
  stopOpacity: 0.0981
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6721,
  stopColor: "#f0f3f6",
  stopOpacity: 0.1789
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7376,
  stopColor: "#e8ecf1",
  stopOpacity: 0.2842
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7957,
  stopColor: "#dee3eb",
  stopOpacity: 0.4144
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8482,
  stopColor: "#d2dae4",
  stopOpacity: 0.5696
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8965,
  stopColor: "#c4cedc",
  stopOpacity: 0.7502
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9394,
  stopColor: "#b5c1d3",
  stopOpacity: 0.947
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9497,
  stopColor: "#b1bed1"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient-5",
  cx: -346.7226,
  cy: 4629.4329,
  r: 3037.077,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ff931e",
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3101,
  stopColor: "#ff9a2d",
  stopOpacity: 0.1871
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5678,
  stopColor: "#ffb05a",
  stopOpacity: 0.1468
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8058,
  stopColor: "#ffd4a6",
  stopOpacity: 0.0793
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient-6",
  cx: 1780.0601,
  cy: 509.6519,
  r: 1280.5548,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ff931e",
  stopOpacity: 0.7
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2609,
  stopColor: "#ff9421",
  stopOpacity: 0.6903
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4135,
  stopColor: "#ff9a2c",
  stopOpacity: 0.6579
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5384,
  stopColor: "#ffa23d",
  stopOpacity: 0.6024
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6482,
  stopColor: "#ffae57",
  stopOpacity: 0.5239
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7481,
  stopColor: "#ffbe77",
  stopOpacity: 0.4221
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8408,
  stopColor: "#ffd1a0",
  stopOpacity: 0.2968
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9263,
  stopColor: "#ffe8ce",
  stopOpacity: 0.1513
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient-7",
  cx: 1515.0601,
  cy: 1657.1519,
  r: 1084.1097,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b1bed1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.102,
  stopColor: "#b3c0d2",
  stopOpacity: 0.9681
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2469,
  stopColor: "#bac6d7",
  stopOpacity: 0.8789
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4175,
  stopColor: "#c6cfdd",
  stopOpacity: 0.7324
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6076,
  stopColor: "#d6dde7",
  stopOpacity: 0.5286
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8112,
  stopColor: "#eaedf3",
  stopOpacity: 0.2708
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-2",
  x1: 1928.5979,
  y1: 4911.2009,
  x2: 168.5702,
  y2: 75.5644,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.7003,
  stopColor: "#fefefe",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7425,
  stopColor: "#eef1f5",
  stopOpacity: 0.2078
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8163,
  stopColor: "#d4dbe5",
  stopOpacity: 0.5445
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8779,
  stopColor: "#c1cbda",
  stopOpacity: 0.7909
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9241,
  stopColor: "#b5c2d4",
  stopOpacity: 0.9429
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9497,
  stopColor: "#b1bed1"
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1920,4500H0V0H1920Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M1920,4500H0V0H1920Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M1920,4500H0V0H1920Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1920,4500H0V0H1920Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M1920,4500H0V0H1920Z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M1920,4500H0V0H1920Z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M1920,4500H0V0H1920Z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M1920,4500H0V0H1920Z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1920,4500H0V0H1920Z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "M1920,4500H0V0H1920Z"
});

var SvgBackgroundColorfulV3 = function SvgBackgroundColorfulV3(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1920 4500",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, ">\r\n    ", _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBackgroundColorfulV3, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/background_colorful_v3.c3b0a12a.svg";
export { ForwardRef as ReactComponent };